import { useEffect, useState } from "react"
import { getAiRoleContent, updateAiRoleContent } from "../../features/aiControl/aiControlSlice"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import InputTextarea from "../../components/shared/input/new/InputTextarea"
import PageTopTitle from "../../components/shared/PageTopTitle"
import Button from "../../components/shared/button/Btn";
import { useSelector } from "react-redux"
import InputTextareaContent from "../../components/shared/input/ai/InputTextareaContent"
import moment from "moment"

const Container = styled.div`
  width: 100%;
  height: 100%;
  .content{
    margin: 30px;
    gap: 25px;
    display: flex;
    flex-direction: column;
  }
`

const YapayZekaRoleContent = () => {
  const dispatch = useDispatch()
  const {aiRole} = useSelector((state) => state.aiControl)
  const [role, setRole] = useState("")

  useEffect(() => {
    if(aiRole){
      setRole(aiRole.content)
    }
  }, [aiRole])
  
  useEffect(() => {
    dispatch(getAiRoleContent())
  }, [])

  const handleSubmit = () => {
    dispatch(updateAiRoleContent({content: role}))
  }

  return (
    <Container>
      <div className="wrapper">
        <PageTopTitle title={"Yapay Zeka Rol Belirleme"} position="sticky" />

        <div className="content">
          <InputTextareaContent name={"data"} data={role} setData={setRole} inputWidth={"500px"} labelText={"Rol Tanımı"} />
          <p><b>Son Güncelleme:</b> {moment(aiRole?.updatedAt).format('LLL')}</p>
          <Button handleClick={handleSubmit} bgColor={"transparent"} color={"#E85546"} padding="0 10px" width="160px">Güncelle</Button>
        </div>

      </div>
    </Container>
  )
}

export default YapayZekaRoleContent